import { Card } from "reactstrap";

const Categories = ({ items, categoryHandler }) => {
  return (
    <div className="categories-outer">
      <div className={`categories-inner ${items.length === 4 && "four-cards"}`}>
        {items.map((i) => (
          <Card
            className="cardStyle"
            role="button"
            key={i.name}
            onClick={() => categoryHandler(i)}
          >
            <img src={i.image} />
            <p>{i.name}</p>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Categories;
